import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class platformStatsFbPagePostDaily_template extends vnTemplate{

    protected getTemplateHtml(): string{
        return `

           <h1>platformStats fbPage post Daily</h1>
           `;
    }

    protected getTemplateName(): string{
        return "platformStatsFbPagePostDaily_template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;
        return  {
            stats: ko.observableArray([])
            ,brandIcons: ko.observableArray([])
            ,date: ko.observable("")
            ,isLoading: ko.observable(0)
        };

    }

    public activateLoading(){

        this.getTemplateViewModel().isLoading(1);
    }

    public deactivateLoading(){

        this.getTemplateViewModel().isLoading(0);
    }

    public setStats(stats: Array<any>): void{

        this.getTemplateViewModel().stats(stats);
    }

    public setDate(data: string){


        this.getTemplateViewModel().date(data);
    }

    public setBrands(brands: Array<any>): void {

        let finalBrands = [];
        for(let b of brands) {

            finalBrands[b.id] = b.iconImage;
        }

        this.getTemplateViewModel().brandIcons(finalBrands);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/platformStatsFbPagePostDaily_template.ts